module.exports = require("leaflet.locatecontrol");


//////////////////
// WEBPACK FOOTER
// external "leaflet.locatecontrol"
// module id = 6
// module chunks = 0